import React, { FunctionComponent } from "react";
import {
  AttackFramework,
  withStyling,
  latestEnterpriseMatrix,
  enterpriseMatrix,
  mobileMatrix
} from "@ticore/metadata";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import { RenderWhen } from "../../../../../components";
import {
  MitreAttack,
  MitreAttackTactic
} from "../../../@types/rldynamicanalysis";

type RlCloudSandboxMitreAttackProps = {
  attackData?: MitreAttack;
  titaniumUI?: boolean;
  useLatest?: boolean;
  disablePopup?: boolean;
  disableShowAll?: boolean;
};

const RlCloudSandboxMitreAttack: FunctionComponent<
  RlCloudSandboxMitreAttackProps
> = ({ attackData, titaniumUI, useLatest, disablePopup, disableShowAll }) => {
  const enterpriseMatrixData = useLatest
    ? latestEnterpriseMatrix
    : enterpriseMatrix;
  const enterpriseTacticIds = new Set(
    (enterpriseMatrixData as MitreAttackTactic[]).map(tactic => tactic.id)
  );
  const mobileTacticIds = new Set(
    (mobileMatrix as MitreAttackTactic[]).map(tactic => tactic.id)
  );

  const enterpriseAttackData = attackData?.Enterprise?.filter(tactic =>
    enterpriseTacticIds.has(tactic.id)
  );

  const mobileAttackData = attackData?.Enterprise?.filter(tactic =>
    mobileTacticIds.has(tactic.id)
  );

  const showMatrixTypeInTitle = (mobileAttackData?.length ?? 0) > 0;

  return (
    <div className={"ticore-metadata"}>
      {attackData ? (
        <div>
          <RenderWhen condition={(enterpriseAttackData?.length ?? 0) > 0}>
            <div className={"pb-20"}>
              <AttackFramework
                attack={{
                  Enterprise: enterpriseAttackData as MitreAttackTactic[]
                }}
                titaniumUI={titaniumUI}
                useLatest={useLatest}
                disablePopup={disablePopup}
                disableShowAll={disableShowAll}
                showMatrixTypeInTitle={showMatrixTypeInTitle}
              />
            </div>
          </RenderWhen>
          <RenderWhen condition={(mobileAttackData?.length ?? 0) > 0}>
            <AttackFramework
              attack={{
                Enterprise: mobileAttackData as MitreAttackTactic[]
              }}
              titaniumUI={titaniumUI}
              useLatest={useLatest}
              disablePopup={disablePopup}
              disableShowAll={disableShowAll}
              matrixType={"Mobile"}
              showMatrixTypeInTitle={showMatrixTypeInTitle}
            />
          </RenderWhen>
        </div>
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.mitre_attack}</b>
      )}
    </div>
  );
};

export default withStyling(RlCloudSandboxMitreAttack);
